module.exports = __webpack_public_path__ + "static/media/CT_2019_30457.80d375f5.png";